import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { SideBar } from "../../../components/CattleMap/SideBarMenu/Index";
import { EditOnboardingProvider } from "../../../contexts/EditOnboardingContext";
import { useFilter } from "../../../hooks/useFilter";
import { Index } from "../Maps/Template/Index";
import { ShowData } from "../ShowData";
import "./styles.css";
import { SystemManager } from "../ShowData/SystemManager";
import { farmService } from "../../../services/farmService";
import { areaService } from "../../../services/areaService";
import { FilterContextV2Provider } from "../../../contexts/FilterContextV2";

export function PaddocksMapIndex() {
  const {
    sideBarOptionSelected,
    setResponseFarms,
    setResponseArea,
    setPaddockMapCatalogLoadError,
  } = useFilter();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadFarmsAndAreas = async () => {
      setPaddockMapCatalogLoadError(false);
      try {
        const responseFarms = await farmService.getFarmsByUser();
        if (cancelled) return;
        setResponseFarms(responseFarms);

        if (responseFarms.length > 0) {
          const responseArea = await areaService.getAreasByUser();
          if (cancelled) return;
          setResponseArea(responseArea);
        } else {
          setResponseArea([]);
        }
      } catch (error) {
        console.error("Erro ao carregar fazendas/retiros:", error);
        if (!cancelled) {
          setPaddockMapCatalogLoadError(true);
          setResponseFarms([]);
          setResponseArea([]);
        }
      }
    };

    loadFarmsAndAreas();

    return () => {
      cancelled = true;
    };
  }, [setResponseFarms, setResponseArea, setPaddockMapCatalogLoadError]);

  useEffect(() => {
    const handleSidebarToggle = (event: CustomEvent) => {
      setSidebarExpanded(event.detail.isOpen);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle as EventListener);
    
    return () => {
      window.removeEventListener('sidebarToggle', handleSidebarToggle as EventListener);
    };
  }, []);

  return (
    <FilterContextV2Provider>
      <section className={`paddocksmap__container--template ${sidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
        <SideBar />
        <main style={{ background: "#F1F1F1" }}>
          {sideBarOptionSelected == "MAPA" || sideBarOptionSelected == "DASHBOARD" ? (
            <Index>
              <Outlet />
            </Index>
          ) : (
            <EditOnboardingProvider>
              <SystemManager />
            </EditOnboardingProvider>
          )}
        </main>
      </section>
    </FilterContextV2Provider>
  );
}
